export const PACKAGE_MANAGER_SOURCE_NODES_SETTINGS = "nodes-settings";
export const PACKAGE_MANAGER_SOURCE_USER_ITEMS = "user-items";
